import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Slide, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "../../../components/Header";
import Loader from "../../../components/Loader";
import stopWatch from "../../../images/stopwatch.svg";

const Home = () => {
  let lsUser = JSON.parse(localStorage.getItem("user"));
  let userId = lsUser.staff_id;
  let [user, setUser] = useState({});
  let [employee, setEmployee] = useState({});
  const [isUpdate, setIsUpdate] = useState(false);
  const [greeting, setGreeting] = useState("");
  const token = localStorage.getItem("token");
  const api_url = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  const [longitude, setLongitude] = useState("");
  const [latitude, setLatitude] = useState("");

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setLongitude(position.coords.longitude);
        setLatitude(position.coords.latitude);
      });
    } else {
      toast.error("Geolocation is not supported by this browser.", {
        hideProgressBar: true,
        theme: "colored",
      });
    }
  }, []);

  console.log(longitude, latitude);

  useEffect(() => {
    if (token) {
      const hour = new Date().getHours();

      if (hour >= 5 && hour < 12) {
        setGreeting("good morning, ");
      } else if (hour >= 12 && hour < 18) {
        setGreeting("good afternoon, ");
      } else {
        setGreeting("good evening, ");
      }
      try {
        fetch(api_url + `users/${userId}`, {
          method: "GET",
          headers: {
            authorization: token,
          },
        })
          .then((response) => response.json())
          .then((data) => {
            setUser(data.user);
          });
      } catch (error) {
        console.log(error);
      }
    }
  }, [api_url, userId, token]);

  const { outlet_code, outlet, location, staff_id, name, designation, phone } =
    user;

  useEffect(() => {
    try {
      fetch(api_url + `employees/${userId}`, {
        method: "GET",
        headers: {
          authorization: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setEmployee(data.employee);
        });
    } catch (error) {
      console.log(error);
    }
  }, [api_url, userId, token, isUpdate, navigate]);

  const checkIn = () => {
    let newData = {
      outlet_code,
      outlet,
      location,
      staff_id,
      name,
      designation,
      phone,
      date: new Date(),
      checkin: new Date().toLocaleTimeString("en-us"),
      checkout: "",
      isChecked: true,
    };

    // const currentLongitude = parseFloat(longitude).toFixed(2);
    // const currentLatitude = parseFloat(latitude).toFixed(2);

    // const userLongitude = parseFloat(user.longitude).toFixed(2);
    // const userLatitude = parseFloat(user.latitude).toFixed(2);

    // console.log("Current Location:", currentLongitude, currentLatitude);
    // console.log("Outlet Location:", userLongitude, userLatitude);
    // const isSameLocation =
    //   currentLongitude === userLongitude && currentLatitude === userLatitude;

    // if (!isSameLocation) {
    //   let message = "You're not in outlet location";
    //   toast.error(message, {
    //     hideProgressBar: true,
    //     theme: "colored",
    //   });
    //   return;
    // } else {
    try {
      fetch(api_url + "employees", {
        method: "POST",
        headers: {
          authorization: token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status) {
            let message = `You check in at ${new Date().toLocaleTimeString(
              "en-US"
            )}`;
            toast.success(message, {
              position: "top-center",
              hideProgressBar: true,
              theme: "colored",
            });
            setIsUpdate(true);
          } else {
            let message = data.message;
            toast.error(message, {
              hideProgressBar: true,
              theme: "colored",
            });
          }
        })
        .catch((error) => console.log(error));
    } catch (error) {
      console.log(error);
    }
    setIsUpdate(false);
    // }
  };

  const checkOut = () => {
    let newData = {
      outlet_code,
      outlet,
      location,
      staff_id,
      name,
      designation,
      phone,
      checkout: new Date().toLocaleTimeString("en-us"),
      isChecked: false,
    };

    // const currentLongitude = parseFloat(longitude).toFixed(2);
    // const currentLatitude = parseFloat(latitude).toFixed(2);

    // const userLongitude = parseFloat(user.longitude).toFixed(2);
    // const userLatitude = parseFloat(user.latitude).toFixed(2);

    // console.log("Current Location:", currentLongitude, currentLatitude);
    // console.log("Outlet Location:", userLongitude, userLatitude);
    // const isSameLocation =
    //   currentLongitude === userLongitude && currentLatitude === userLatitude;

    // if (!isSameLocation) {
    //   let message = "You're not in outlet location";
    //   toast.error(message, {
    //     hideProgressBar: true,
    //     theme: "colored",
    //   });
    //   return;
    // } else {
    try {
      fetch(api_url + `employees/${employee.staff_id}`, {
        method: "PATCH",
        headers: {
          authorization: token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status) {
            let message = `You check out at ${new Date().toLocaleTimeString(
              "en-US"
            )}`;
            toast.success(message, {
              position: "top-center",
              hideProgressBar: true,
              theme: "colored",
            });
            setIsUpdate(true);
          } else {
            let message = data.message;
            toast.error(message, {
              hideProgressBar: true,
              theme: "colored",
            });
          }
        })
        .catch((error) => console.log(error));
    } catch (error) {
      console.log(error);
    }
    setIsUpdate(false);
    // }
  };

  const isCompleteTodayCheckout = !employee?.isChecked && new Date().toISOString().split("T")[0] === employee?.date?.split("T")[0];

  const isMissedOut =
    employee?.isChecked &&
    employee?.checkout === "" &&
    employee?.date?.split("T")[0] !== new Date().toISOString().split("T")[0];

  return (
    <>
      <ToastContainer transition={Slide} />
      <div className="employee bg-white h-full">
        <Header />
        {!user.name ? (
          <Loader />
        ) : (
          <>
            <div className="employee-info">
              <div className="image mt-10">
                <img className="mx-auto" src={stopWatch} alt="stopwatch" />
              </div>
              <div className="name text-sm text-center font-semibold capitalize my-3">
                {greeting}
                <span className="text-[#EB4B50]">{user.name + "!"}</span>
              </div>
              <div className="outlet-info text-xs text-[#373434] font-semibold flex items-center justify-center gap-2">
                <div className="code">{user.outlet_code}</div>
                <div className="bar w-[2px] h-3 bg-[#373434]"></div>
                <div className="name">{user.outlet}</div>
              </div>
              {isMissedOut ? (
                <div className="missed-out text-[#64798A] text-sm text-center font-semibold mt-3">
                  You missed your last check out
                </div>
              ) : null}
            </div>
            {isCompleteTodayCheckout ? (
              <div className="complete-message text-center mt-5 px-5">
                <div className="text-green-500 text-lg font-semibold capitalize">
                  thank you
                </div>
                <div className="text-[#64798A] text-sm font-semibold mt-2">
                  Your attendance is complete
                </div>
              </div>
            ) : (
              <div className="employee-button mt-5 px-5">
                {!employee?.isChecked || isMissedOut ? (
                  <button
                    className="w-full rounded text-sm bg-green-500 text-white font-semibold capitalize p-3 disabled:opacity-70 disabled:cursor-not-allowed"
                    onClick={checkIn}
                  >
                    check in
                  </button>
                ) : (
                  <button
                    className="w-full rounded text-sm bg-button text-white font-semibold capitalize p-3"
                    onClick={checkOut}
                  >
                    check out
                  </button>
                )}
              </div>
            )}
            <div className="attendance-history rounded shadow border-t border-solid border-gray-100 flex items-center justify-between gap-2 mt-5 mx-5 p-5">
              <div className="date">
                <div className="title text-xs text-[#64798A] font-semibold capitalize mb-1">
                  date
                </div>
                <div className="text text-[10px] font-semibold text-[#1E1E1E] capitalize">
                  {new Date(employee?.date).toLocaleDateString("en-UK") ===
                    "Invalid Date"
                    ? "----------------"
                    : new Date(employee.date).toLocaleDateString("en-UK", {
                      dateStyle: "medium",
                    })}
                </div>
              </div>
              <div className="checkIn">
                <div className="title text-xs text-[#64798A] font-semibold capitalize mb-1">
                  check in
                </div>
                <div className="text text-[10px] font-semibold text-[#1E1E1E] capitalize">
                  {employee?.checkin ? employee.checkin : "--------------"}
                </div>
              </div>
              <div className="checkOut">
                <div className="title text-xs text-[#64798A] font-semibold capitalize mb-1">
                  check out
                </div>
                <div className="text text-[10px] font-semibold text-[#1E1E1E] capitalize">
                  {employee?.checkout ? employee.checkout : "-------------"}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Home;
